import useHasAccessToAirAmbulance from '@rsos/hooks/useHasAccessToAirAmbulance';
import useHasAccessToNorfolkSouthern from '@rsos/hooks/useHasAccessToNorfolkSouthern';
import useHasAccessToTowPro from '@rsos/hooks/useHasAccessToTowPro';

/**
 * Whether the user can reach the Resource Request panel: true when any
 * resource request type (Air Ambulance, TowPro, Norfolk Southern consists)
 * is available to them.
 */
const useHasAccessToResourceRequests = (): boolean => {
  const hasAccessToAirAmbulance = useHasAccessToAirAmbulance();
  const hasAccessToTowPro = useHasAccessToTowPro();
  const hasAccessToNorfolkSouthern = useHasAccessToNorfolkSouthern();

  return (
    hasAccessToAirAmbulance || hasAccessToTowPro || hasAccessToNorfolkSouthern
  );
};

export default useHasAccessToResourceRequests;
